// services/admin/categoryService.js
import { apiClient } from './apiClient';

export const categoryService = {
  /**
   * Получить все категории
   * @returns {Promise<Category[]>}
   */
  async getAllCategories() {
    return apiClient.get('/categories');
  },

  /**
   * Получить категорию по ID
   * @param {number} id
   * @returns {Promise<Category>}
   */
  async getCategoryById(id) {
    return apiClient.get(`/categories/${id}`);
  },

  /**
   * Получить категории по типу
   * @param {string} type
   * @returns {Promise<Category[]>}
   */
  async getCategoriesByType(type) {
    return apiClient.get(`/categories/type/${type}`);
  },

  /**
   * Создание категории
   * @param {string} name
   * @param {string} description
   * @param {string} type
   * @returns {Promise<Category>}
   */
  async createCategory(name, description, type) {
    const params = new URLSearchParams();
    params.append('name', name);
    if (description) params.append('description', description);
    params.append('type', type);
    
    const url = `${apiClient.baseUrl}/categories?${params.toString()}`;
    console.log('POST запрос к:', url);
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Ошибка при создании категории');
    }
    
    const result = await response.json();
    console.log('Ответ сервера:', result);
    
    return result;
  },

  /**
   * Обновление категории
   * @param {number} id
   * @param {string} name
   * @param {string} description
   * @param {string} type
   * @returns {Promise<Category>}
   */
  async updateCategory(id, name, description, type) {
    const url = `${apiClient.baseUrl}/categories/${id}`;
    console.log('PUT запрос к:', url);
    
    // Отправляем объект, который соответствует сущности Category
    const categoryData = {
        name: name,
        description: description,
        type: type
    };
    
    console.log('Тело запроса:', categoryData);
    
    const response = await fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(categoryData)
    });
    
    if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || 'Ошибка при обновлении категории');
    }
    
    const result = await response.json();
    console.log('Ответ сервера:', result);
    
    return result;
  },

  /**
   * Удаление категории
   * @param {number} id
   * @returns {Promise<void>}
   */
  async deleteCategory(id) {
    return apiClient.delete(`/categories/${id}`);
  },

  /**
   * Обновление списка локаций для категории
   * @param {number} categoryId
   * @param {number[]} locationIds
   * @returns {Promise<void>}
   */
  async updateCategoryLocations(categoryId, locationIds) {
    if (!categoryId) {
      throw new Error('categoryId обязателен');
    }
    
    console.log(`Обновляем локации для категории ${categoryId}:`, locationIds);
    
    // Отправляем массив ID напрямую (без обёртки itemIds)
    return apiClient.put(`/categories/${categoryId}/locations`, locationIds);
  },

  /**
   * Обновление списка маршрутов для категории
   * @param {number} categoryId
   * @param {number[]} routeIds
   * @returns {Promise<void>}
   */
  async updateCategoryRoutes(categoryId, routeIds) {
    if (!categoryId) {
      throw new Error('categoryId обязателен');
    }
    
    console.log(`Обновляем маршруты для категории ${categoryId}:`, routeIds);
    
    return apiClient.put(`/categories/${categoryId}/routes`, routeIds);
  },

  /**
   * Получение всех локаций категории
   * @param {number} categoryId
   * @returns {Promise<Location[]>}
   */
  async getCategoryLocations(categoryId) {
    return apiClient.get(`/categories/${categoryId}/locations`);
  },

  /**
   * Получение всех маршрутов категории
   * @param {number} categoryId
   * @returns {Promise<Route[]>}
   */
  async getCategoryRoutes(categoryId) {
    return apiClient.get(`/categories/${categoryId}/routes`);
  },

  /**
   * Добавление локации в категорию
   * @param {number} categoryId
   * @param {number} locationId
   * @returns {Promise<void>}
   */
  async addLocationToCategory(categoryId, locationId) {
    return apiClient.post(`/categories/${categoryId}/locations/${locationId}`);
  },

  /**
   * Удаление локации из категории
   * @param {number} categoryId
   * @param {number} locationId
   * @returns {Promise<void>}
   */
  async removeLocationFromCategory(categoryId, locationId) {
    return apiClient.delete(`/categories/${categoryId}/locations/${locationId}`);
  },

  /**
   * Добавление маршрута в категорию
   * @param {number} categoryId
   * @param {number} routeId
   * @returns {Promise<void>}
   */
  async addRouteToCategory(categoryId, routeId) {
    return apiClient.post(`/categories/${categoryId}/routes/${routeId}`);
  },

  /**
   * Удаление маршрута из категории
   * @param {number} categoryId
   * @param {number} routeId
   * @returns {Promise<void>}
   */
  async removeRouteFromCategory(categoryId, routeId) {
    return apiClient.delete(`/categories/${categoryId}/routes/${routeId}`);
  }
};